import * as React from 'react';

import { useValidationsContext } from '../context/validations-context';

export function useStepManager(initialStep = 1, lastStep) {
  const [currentStep, setCurrentStep] = React.useState(initialStep);

  const {
    handleValidateVideoApresentation,
    handleValidateFormData,
    handleValidateAceptedTerms,
  } = useValidationsContext();

  const stepValidators = React.useMemo(
    () => [
      null,
      handleValidateVideoApresentation,
      handleValidateAceptedTerms,
      handleValidateFormData,
    ],
    [
      handleValidateVideoApresentation,
      handleValidateAceptedTerms,
      handleValidateFormData,
    ],
  );

  const canGoBack = React.useMemo(() => {
    return currentStep > 0;
  }, [currentStep]);

  const goToNext = React.useCallback(async () => {
    const validator = stepValidators[currentStep];

    if (validator) {
      const isValid = await validator();
      if (!isValid) {
        return;
      }
    }
    // if (currentStep === 4) {
    //   const newUrl = getActualUri().replaceAll('sobre-curso', 'avaliacao');
    //   console.log('aqui',getActualUri())
    //   navigateTo(newUrl)
    //   return;
    // }

    setCurrentStep((prev) => {
      return prev + 1;
    });
  }, [stepValidators, currentStep]);

  const goToPrevious = React.useCallback(() => {
    if (canGoBack) {
      setCurrentStep((prev) => prev - 1);
    }
  }, [canGoBack]);

  const goToStep = React.useCallback((stepIndex) => {
    setCurrentStep(stepIndex);
  }, []);

  return {
    currentStep,
    canGoBack,
    goToNext,
    goToPrevious,
    goToStep,
  };
}
